import { useEffect, useState } from "react";
import { App } from "antd";
import { fetchCategories } from "../api";

// Todas las categorías del catálogo (para el formulario)
export default function useCategories() {
  const { message } = App.useApp();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories()
      .then(setCategories)
      .catch((error) => {
        console.error(error);
        message.error("No se pudieron cargar todas las categorías");
      });
  }, [message]);

  return { categories };
}
